/*global VeloxViewController, VeloxWebView*/

var viewsTree = require("../../views_tree.json") ;

var helpController = new VeloxViewController({
    directory : "views/help",
    name: "help",
    container: "main",
    route: "help"
}) ;

function flattenEntry(entries, entry, level){
    entry.level = level;
    entry.hasChildren = !!entry.children;
    if(!entry.hasChildren && !/\.md$/.test(entry.name)){
        return ;
    }
    entry.path = entry.path.replace(/^src\//, "").replace("/"+entry.name, "") ;
    entry.filename = entry.name.replace(/\.md$/, "") ;
    entry.name = entry.name.replace(/\.md$/, "").replace(/^[0-9]{2}-/, "") ;
    entries.push(entry) ;
    if(entry.children){
        entry.children.forEach(function(c){
            flattenEntry(entries, c, level+1) ;
        }) ;
    }
}

helpController.prepareDataOnEnter = function(data, callback){
    var data = {} ;
    var lang = VeloxWebView.i18n.getLang().substring(0,2) ;
    data.flatHierarchy = [];
    
    var helpEntries = viewsTree.children.filter(function(c){ return c.name === "help" ;}) ;
    if(helpEntries.length > 0){
        var helpEntry = helpEntries[0] ;
        var mdEntries = helpEntry.children.filter(function(c){ return c.name === "markdown" ;}) ;
        if(mdEntries.length > 0){
            var mdEntry = mdEntries[0] ;
            var frEntries = mdEntry.children.filter(function(c){ return c.name === lang ;}) ;
            if(frEntries.length > 0){
                var frEntry = frEntries[0] ;
                frEntry.children.forEach(function(c){
                    flattenEntry(data.flatHierarchy, c, 0) ;
                }) ;
            }
        }
    }

    callback(null, data) ;
};

helpController.openEntry = function(entry) {
    this.data.flatHierarchy.forEach(function(e){
        e.selected = false ;
    }) ;
    entry.selected = true ;
    this.view.render() ;
    var view = new VeloxWebView(entry.path, entry.filename, {container: this.view.EL.contents}) ;
    view.open()  ;
} ;

helpController.onHelpEntry = function(ev){
    var entry = ev.data.data ;
    helpController.openEntry(entry) ;
} ;

helpController.onDisplayed = function(){
    var entry = this.data.flatHierarchy.filter(function(e){ return !e.hasChildren ;})[0] ;
    if(entry){
        helpController.openEntry(entry) ;
    }
} ;


module.exports = helpController ;